import React from 'react';

const CalendarDots = ({
  width = '17',
  height = '17',
  fill = 'none',
  ...props
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 17 17"
    xmlns="http://www.w3.org/2000/svg"
    fill={fill}
    {...props}
  >
    <g opacity="0.5">
      <path
        d="M4.56641 1.57666V3.07052"
        stroke="#222222"
        strokeWidth="1.65984"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.0312 1.57666V3.07052"
        stroke="#222222"
        strokeWidth="1.65984"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.5812 14.584C14.3012 14.8641 13.9212 15.0216 13.5251 15.0217H3.06808C2.67188 15.0217 2.29191 14.8643 2.01176 14.5841C1.73161 14.304 1.57422 13.924 1.57422 13.5278V4.56466C1.57422 4.16846 1.73161 3.78849 2.01176 3.50834C2.29191 3.22819 2.67188 3.0708 3.06808 3.0708H13.5251C13.9213 3.0708 14.3012 3.22819 14.5814 3.50834C14.8616 3.78849 15.0189 4.16846 15.0189 4.56466V13.5278C15.0189 13.924 14.8614 14.3039 14.5812 14.584Z"
        stroke="#222222"
        strokeWidth="1.65984"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.75237 7.69273C4.65332 7.69273 4.55833 7.65338 4.48829 7.58334C4.41825 7.51331 4.37891 7.41831 4.37891 7.31927C4.37891 7.22022 4.41825 7.12522 4.48829 7.05519C4.55833 6.98515 4.65332 6.9458 4.75237 6.9458"
        stroke="#222222"
        strokeWidth="1.65984"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.75 7.69273C4.84905 7.69273 4.94404 7.65338 5.01408 7.58334C5.08412 7.51331 5.12346 7.41831 5.12346 7.31927C5.12346 7.22022 5.08412 7.12522 5.01408 7.05519C4.94404 6.98515 4.84905 6.9458 4.75 6.9458"
        stroke="#222222"
        strokeWidth="1.65984"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.75237 11.1463C4.65332 11.1463 4.55833 11.107 4.48829 11.037C4.41825 10.9669 4.37891 10.8719 4.37891 10.7729C4.37891 10.6738 4.41825 10.5788 4.48829 10.5088C4.55833 10.4388 4.65332 10.3994 4.75237 10.3994"
        stroke="#222222"
        strokeWidth="1.65984"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.75 11.1463C4.84905 11.1463 4.94404 11.107 5.01408 11.037C5.08412 10.9669 5.12346 10.8719 5.12346 10.7729C5.12346 10.6738 5.08412 10.5788 5.01408 10.5088C4.94404 10.4388 4.84905 10.3994 4.75 10.3994"
        stroke="#222222"
        strokeWidth="1.65984"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.29925 7.69273C8.2002 7.69273 8.1052 7.65338 8.03517 7.58334C7.96513 7.51331 7.92578 7.41831 7.92578 7.31927C7.92578 7.22022 7.96513 7.12522 8.03517 7.05519C8.1052 6.98515 8.2002 6.9458 8.29925 6.9458"
        stroke="#222222"
        strokeWidth="1.65984"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.30078 7.69273C8.39983 7.69273 8.49482 7.65338 8.56486 7.58334C8.6349 7.51331 8.67425 7.41831 8.67425 7.31927C8.67425 7.22022 8.6349 7.12522 8.56486 7.05519C8.49482 6.98515 8.39983 6.9458 8.30078 6.9458"
        stroke="#222222"
        strokeWidth="1.65984"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.29925 11.1463C8.2002 11.1463 8.1052 11.107 8.03517 11.037C7.96513 10.9669 7.92578 10.8719 7.92578 10.7729C7.92578 10.6738 7.96513 10.5788 8.03517 10.5088C8.1052 10.4388 8.2002 10.3994 8.29925 10.3994"
        stroke="#222222"
        strokeWidth="1.65984"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.30078 11.1463C8.39983 11.1463 8.49482 11.107 8.56486 11.037C8.6349 10.9669 8.67425 10.8719 8.67425 10.7729C8.67425 10.6738 8.6349 10.5788 8.56486 10.5088C8.49482 10.4388 8.39983 10.3994 8.30078 10.3994"
        stroke="#222222"
        strokeWidth="1.65984"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.85 7.69273C11.751 7.69273 11.656 7.65338 11.5859 7.58334C11.5159 7.51331 11.4766 7.41831 11.4766 7.31927C11.4766 7.22022 11.5159 7.12522 11.5859 7.05519C11.656 6.98515 11.751 6.9458 11.85 6.9458"
        stroke="#222222"
        strokeWidth="1.65984"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.8477 7.69273C11.9467 7.69273 12.0417 7.65338 12.1117 7.58334C12.1818 7.51331 12.2211 7.41831 12.2211 7.31927C12.2211 7.22022 12.1818 7.12522 12.1117 7.05519C12.0417 6.98515 11.9467 6.9458 11.8477 6.9458"
        stroke="#222222"
        strokeWidth="1.65984"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  </svg>
);

export default CalendarDots;
